export default __webpack_public_path__ + "static/media/white-horse-crop.ba830913.jpg";